import axios from '../../helpers/axios'
import { logError } from '../../services';
import { IDropdownResponse, ILot, INeighborhoodRes, IPeopleRes } from '../../models';

const sharedBase = `/api/shared/lookup`;
const commonBase = `/api/common/lookup`;

export const getCommonLookupVendors = async (
  hasPunchLists: boolean = false
): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${sharedBase}/vendors`, { params: { hasPunchLists } });

    return data;
  } catch (error: any) {
    logError(error, 'getCommonLookupVendors failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getCommonLookupStates = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${sharedBase}/states`);

    return data;
  } catch (error: any) {
    logError(error, 'getCommonLookupStates failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getAdminLookupStates = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${commonBase}/states`);

    return data;
  } catch (error: any) {
    logError(error, 'getCommonLookupStates failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getCommonLookupLenders = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${sharedBase}/lenders`);

    return data;
  } catch (error: any) {
    logError(error, 'getCommonLookupLenders failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getCommonNeighborhoods = async (
  filters: {
    territoryId?: number;
    page?: number;
    perPage?: number | string;
    sortBy?: string;
    sortDirection?: string;
    isActive?: boolean;
    hasActiveJobs?: boolean;
    hasActiveBuilds?: boolean;
    hasAvailableLots?: boolean;
    name?: string;
    code?: string | number;
    search?: string;
    hasSpecs?: boolean;
    hasPunchLists?: boolean;
    includeGeneralJob?: boolean;
    underContractBuildsOnly?: boolean;
  } = { sortBy: 'Name' }
): Promise<INeighborhoodRes> => {
  try {
    const { data } = await axios.get(`${sharedBase}/neighborhoods-list`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getNeighborhoods failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getCommonNeighborhoodLots = async (filters: {
  neighborhoodId?: number | string;
  isSpec?: boolean;
  includeGeneralJob?: boolean;
}): Promise<ILot[]> => {
  try {
    const { data } = await axios.get(`${sharedBase}/neighborhood-lots`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getNeighborhoodLots failed');
    return Promise.reject(error);
  }
};

export const getCommonPeople = async (params?: {
  name?: string;
  workplace?: string;
  email?: string;
  personType?: string | number;
  isActive?: boolean;
  customRole?: string;
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  query?: string;
  partnerId?: string | number;
  sortDirection?: string;
  vendorTerritoryId?: string | number;
  sageJobId?: number;
}): Promise<IPeopleRes> => {
  try {
    const { data } = await axios.get(`${sharedBase}/people`, {
      params
    });
    return data;
  } catch (error) {
    logError(error, 'getCommonPeople failed');
    return Promise.reject(error);
  }
};
